import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-flex-start items-center gap-x-4" }
const _hoisted_2 = { class: "mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-primary-color-100" }
const _hoisted_3 = { class: "flex justify-end" }

import GgmsModal from "@/components/GgmsModal.vue"
import GgmsInfo from "@/components/GgmsInfo.vue"
import GgmsButton from "@/components/GgmsButton.vue"
import { MailIcon } from "@heroicons/vue/outline"

interface Props {
    open: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'EmailVerificationModal',
  props: {
    open: { type: Boolean }
  },
  emits: ["closeModal"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

function closeModal() {
    emit("closeModal")
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(GgmsModal, {
    open: _ctx.open,
    onCloseModal: closeModal
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(MailIcon), { class: "h-6 w-6 text-primary-color-600" })
        ]),
        _cache[0] || (_cache[0] = _createElementVNode("h1", { class: "text-lg leading-6 font-medium text-gray-900" }, "Please confirm your email", -1))
      ])
    ]),
    under: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(GgmsButton, {
          styleType: "primary",
          onClick: closeModal
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [
            _createTextVNode("OK")
          ])),
          _: 1,
          __: [2]
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(GgmsInfo, { textCenter: false }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createElementVNode("p", null, " We've sent you an email. Please confirm your account by clicking on the verification link that we sent. ", -1)
        ])),
        _: 1,
        __: [1]
      })
    ]),
    _: 1
  }, 8, ["open"]))
}
}

})